import { render, staticRenderFns } from "./UiAccountHeader.vue?vue&type=template&id=228f1aac&lang=pug&"
import script from "./UiAccountHeader.vue?vue&type=script&lang=js&"
export * from "./UiAccountHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports